import { setStageGoal } from './routines'

export default {
  [setStageGoal.TRIGGER](context, payload) {
    context.commit(setStageGoal.TRIGGER, payload)
  }
}
